import ForcesHero from './Forces'
import ForceHero from './Force'
import SimpleHero from './Simple'

export default ForcesHero
export { ForcesHero, ForceHero, SimpleHero }
